export default "<template>\r\n  <v-system-bar></v-system-bar>\r\n</template>\r\n";